import React from 'react';

import { useAccountState, useAccountActions } from './AccountContext';
import { closeCurrentUserAccount } from './restApi';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';

const CloseAccountForm = () => {
  const state = useAccountState();
  const { onResponse, onError, updateCloseAccountFormPassword, updateCloseAccountFormExplicitAcknowledgementPhrase, closeAccountCloseModal } = useAccountActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    closeCurrentUserAccount({
      onResponse,
      onError,
      body: {
        password: state?.closeAccountForm?.password || '',
        explicitAcknowledgementPhrase: state?.closeAccountForm?.explicitAcknowledgementPhrase || '',
        authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field
        label={`Enter phrase: "Close my account. This can not be undone."`}
        id="explicit_acknowledgement_phrase"
      >
        <Input
          type="text"
          value={state?.closeAccountForm?.explicitAcknowledgementPhrase || ''}
          onChange={(e) => updateCloseAccountFormExplicitAcknowledgementPhrase(e.target.value)}
        />
      </Field>

      <Field label="Password" id="password">
        <Input
          type="password"
          value={state?.closeAccountForm?.password || ''}
          onChange={(e) => updateCloseAccountFormPassword(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeAccountCloseModal()}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
          >
            Close Account Permanently
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default CloseAccountForm;
